import * as React from "react";

function SvgStartImaging(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path d="M9.91667 1.41675L32.5833 17.0001L9.91667 32.5834V1.41675Z" fill="#414042" />
    </svg>
  );
}

export default SvgStartImaging;
